import { render, staticRenderFns } from "./PWbankTransfer.vue?vue&type=template&id=6deef52d&scoped=true&"
import script from "./PWbankTransfer.vue?vue&type=script&lang=js&"
export * from "./PWbankTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PWbankTransfer.vue?vue&type=style&index=0&id=6deef52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deef52d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VIcon,VSpacer,VTextField})
